export const messageStatus = {
  pending: "pending",
  visible: "visible",
  skip: "skip",
};

export const messageFrom = {
  bot: "bot",
  human: "human",
};

export const messageType = {
  wait: "wait",
  text: "text",
};
